export default __webpack_public_path__ + "static/media/PatternWhiteSmall.adaff0ad.svg";